const appConfig = window.__APP_CONFIG__ ?? {};

function requireConfig(key) {
  const value = appConfig[key];
  if (!value) {
    throw new Error(`config.js 의 window.__APP_CONFIG__ 에 ${key} 가 없습니다`);
  }
  return value;
}

export const API_BASE_URL = requireConfig('API_BASE_URL');
export const LOGIN_URL = requireConfig('LOGIN_URL');

const config = {
  basename: '/',
  adminPath: '/admin',
  defaultPath: '',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,

  // Feature flags
  features: {
    aiEvaluation: true  // Set to true to enable AI evaluation features
  }
};

export default config;
